<template>
    <div style="height: 630px; overflow-y: auto">
        <div class="side-content mx-auto">
            <div class="mt-3 prod-title position-relative" v-click-outside="disableTitleEditing">
                <textarea
                        :class="{enabledTextarea: !titleReadonly, maxLength: title.length === maxTitle && !titleReadonly}"
                        :readonly='titleReadonly'
                        :maxlength="maxTitle"
                        name="title"
                        id="edit-title"
                        v-model="title"/>
                <div v-if="!titleReadonly">
                    <p v-if="title.length < maxTitle " class="lab" v-text="`${(0 + title.length)}/${maxTitle}`"/>
                    <p class="c5 lab" v-else>Character limit - {{maxTitle}}</p>
                </div>
                <img
                    v-b-tooltip.hover.top
                    title="Edit title"
                    @click="titleEnable"
                    id="edit-title-button"
                    class="position-absolute cursor-pointer"
                    :src="ICON_EDIT"
                    alt="">
            </div>
            <div
                @dragover.prevent
                @drop.prevent="onImageUpload($event.dataTransfer.files[0])"
                class="drag-img-wrap"
                id="edit-image">
                <label v-b-tooltip.hover title="Add picture" for="image" class="w-100 d-flex">
                    <img
                        v-if="cover"
                        :src="cover"
                        class="w-100"/>
                    <DefaultUploadPlace
                        v-else
                        class="mx-auto"/>
                    <input
                        id="image"
                        type="file"
                        accept=".png, .jpg, .jpeg, .gif"
                        @change="onImageUpload($event.target.files[0])"
                        class="d-none"/>
                </label>
                <div class="err-box text-center mt-3" v-if="uploadingError">
                    <span class="c5o7 p2bl">
                        {{uploadingError}}
                    </span>
                </div>
            </div>
            <div class="mt-5 prod-desc position-relative"  v-click-outside="disableDescEditing">
                <textarea
                    :class="{enabledTextarea: !descReadonly, maxLength: desc.length === maxDesc && !descReadonly}"
                    :readonly="descReadonly"
                    :maxlength="maxDesc"
                    v-model="desc"
                    name="description"
                    class="c7 p3n desc_area"
                    id="edit-decription"/>
                <div v-if="!descReadonly">
                    <p v-if="desc.length < maxDesc" class="lab" v-text="`${(0 + desc.length)}/${maxDesc}`"/>
                    <p class="c5 lab" v-else>Character limit - {{maxDesc}}</p>
                </div>
                <img
                    v-b-tooltip.hover
                    id="edit-description-button"
                    title="Edit campaign description"
                    @click="descEnable"
                    class="position-absolute cursor-pointer"
                    :src="ICON_EDIT"
                    alt="">
            </div>
        </div>
    </div>
</template>

<script>
    import { DefaultUploadPlace } from '@/components/Icons'
    import {updateData, uploadImage} from "@/firebaseCRUD";
    import {ICON_EDIT} from "../constants";
    import {clickOutside} from "@/directives/clickOutside";
    import {validateUploading} from "../core/_validateUploading";

    export default {
        name: 'EditCrossPromInfo',
        directives: {
            clickOutside
        },
        components: {
            DefaultUploadPlace
        },
        data() {
            return {
                titleReadonly: true,
                descReadonly: true,
                title: '',
                desc: '',
                cover: null,
                functions: {},
                maxDesc: 400,
                maxTitle: 60,
                childEvent: null,
                uploadingError: '',
                ICON_EDIT
            }
        },
        props: {
            cardData: Object
        },
        watch: {
            'cardData': 'setData'
        },
        computed: {
            crumbs(){
                return [
                    { title: 'My Campaigns' },
                    { title: 'Published', link: '/dashboard/campaigns/publish' },
                    { title: this.cardData.title }
                ]
            }
        },
        methods: {
            hasUnsavedChanges(){
                return (
                    this.title !== this.cardData.promo_title ||
                    this.desc !== this.cardData.promo_desc ||
                    this.cover !== this.cardData.promo_image
                );
            },
            async setData(val) {
                this.title = val.promo_title || ''
                this.desc = val.promo_desc || ''
                this.cover = val.promo_image || null
            },
            async save() {
                const data = {
                    promo_image: this.cover,
                    promo_title: this.title,
                    promo_desc: this.desc,
                };

                await updateData({
                    id: this.$route.query.id,
                    data,
                    collection: 'campaigns'
                });

                await this.$emit('updateCardInfo', data);
            },
            async onImageUpload (file) {
                if(!file) {
                    return;
                }
                this.uploadingError = validateUploading(file);
                if(this.uploadingError) {
                    return
                }
                try {
                    this.cover = URL.createObjectURL(file)
                    this.cover = await uploadImage(file);
                } catch(err) {
                    this.$store.dispatch('handleErrors', err)
                }
            },
            disableTitleEditing: function () {
                this.titleReadonly = true;
            },
            disableDescEditing: function () {
                this.descReadonly = true;
            },
            titleEnable: function () {
                this.titleReadonly = false;
            },
            descEnable: function () {
                this.descReadonly = false;
            },
        },
    }
</script>

<style scoped lang="scss">
    .promo-info {
        .edit-camp-header {
            background: #FFFFFF;
            border-top: 1px solid #F4F4F4;
            border-bottom: 1px solid #F4F4F4;
            height: 100px;
        }
        .left-side,.right-side {
            width: 560px;
            height: 792px;
            padding-top: 50px;
            background: #FFFFFF;
            box-shadow: 0 0 35px rgba(154, 161, 171, 0.15);
            border-radius: 10px;

            #add-updates {
                padding: 0 !important;
            }
        }
        .left-side-content, .right-side-content {
            max-width: 480px;
        }

        .right-side-content {
            .side-content {
                width: 430px;
                border-top: 1px solid #F4F4F4;
                max-height: 660px;
                .prod-desc {
                    p {
                        line-height: 28px;
                    }
                    textarea {
                        font-size: 19px;
                        line-height: 28px;
                        color: #858585;
                    }
                }
                .prod-title, .prod-desc {
                    line-height: 28px;
                    img {
                        top: 0;
                        left: 100%;
                    }
                    p {
                        position: absolute;
                        top: 0;
                        right: 0;
                        transform: translate(0, -22px);
                    }
                }
                textarea {
                    width: 100%;
                    border: 0;
                    font-weight: bold;
                    font-size: 27px;
                    color: #333333;
                    resize: none;

                    &#edit-title {
                        height: 80px;
                    }
                    &#edit-decription {
                        height: 200px;
                    }
                    &.enabledTextarea {
                        border: 1px solid #00000026;
                    }
                    &.maxLength {
                        border: 1px solid #FA5C7C !important;
                    }
                }
            }

        }
    }
    .tabs-actions {
        button, a {
            display: block;
            width: 89px;
            height: 48px;
            text-align: center;
            line-height: 48px;
        }
    }
</style>